export enum CampaignStatus {
  NotActive = 0,
  Active = 1,
  TokenInvalid = 2,
  NotConnected = 3,
  MissingPermission = 4
}
